import React from 'react';
import MkFaq from '../MkFaq';
import { BMB_FAQ } from '../../../marketing/faq';

// B11 — Bring Me Back FAQ.
const BmbFaq = () => (
  <section className="mk-faqsec section" id="faq" aria-labelledby="mk-bmbfaq-title">
    <div className="container-xs">
      <div className="section-inner">
        <div className="mk-head reveal-from-bottom">
          <h2 id="mk-bmbfaq-title" className="mk-h2">
            Questions about Bring Me Back
          </h2>
        </div>
        <MkFaq items={BMB_FAQ} page="bmb" />
      </div>
    </div>
  </section>
);

export default BmbFaq;
